<template>
  <div class="Dashboard">
    <MobileNav :page_title="nav_title"></MobileNav>

    <!-- set_active_link is event emitted frin home page sidebar -->
    <div class="sideBarSection">
      <HomePageSideBar
        @set_active_link="setActiveLink"
        :active_sub_menu="activeSubMenuLink"
        :filterList="filter_list"
        :resetFilters="reset_filter"
        :default_active_filter="default_active_filter"
        :active_period="active_period"
        v-if="isDesktop"
      ></HomePageSideBar>
    </div>

    <div class="reco-details-container">
      <div class="sub-menu-section" id="expertHubSection">
        <div class="sub-menu-bar-wrapper">
          <div class="sub-menu-bar" v-if="active_link == 'TOP_PERFORMERS'">
            <div
              class="sub-menu-bar-link cursor-pointer"
              @click="setActiveSubMenuLink('EXPERTS_HUB')"
              :class="{
                'active-sub-menu-link': activeSubMenuLink == 'EXPERTS_HUB',
              }"
            >
              Experts Hub
            </div>
            <div
              class="sub-menu-bar-link cursor-pointer"
              @click="setActiveSubMenuLink('TOP_EXPERTS')"
              :class="{
                'active-sub-menu-link': activeSubMenuLink == 'TOP_EXPERTS',
              }"
            >
              Top Experts
            </div>
            <div
              class="sub-menu-bar-link cursor-pointer"
              @click="setActiveSubMenuLink('TOP_STOCKS')"
              :class="{
                'active-sub-menu-link': activeSubMenuLink == 'TOP_STOCKS',
              }"
            >
              Top Stocks
            </div>
            <div
              v-if="userProfile.utm_source_str != 'Bigul'"
              class="sub-menu-bar-link cursor-pointer"
              @click="setActiveSubMenuLink('TOP_SECTORS')"
              :class="{
                'active-sub-menu-link': activeSubMenuLink == 'TOP_SECTORS',
              }"
            >
              Top Sectors
            </div>
          </div>

          <div style="margin: 0 15px">
            <!-- v-if="
              activeSubMenuLink == 'EXPERTS_HUB' ||
                activeSubMenuLink == 'TOP_EXPERTS'
            " -->
            <div class="flex">
              <div
                class="period-btn-mini"
                @click="selectPeriod('1M')"
                :class="[active_period == '1M' ? 'active-period-btn-mini' : '']"
              >
                1M
              </div>

              <div
                class="period-btn-mini"
                @click="selectPeriod('3M')"
                :class="[active_period == '3M' ? 'active-period-btn-mini' : '']"
              >
                3M
              </div>
              <div
                class="period-btn-mini"
                @click="selectPeriod('6M')"
                :class="[active_period == '6M' ? 'active-period-btn-mini' : '']"
              >
                6M
              </div>
              <div
                class="period-btn-mini"
                @click="selectPeriod('1Y')"
                :class="[active_period == '1Y' ? 'active-period-btn-mini' : '']"
              >
                1Y
              </div>
              <!-- <div
                class="period-btn-mini"
                @click="selectPeriod('MAX')"
                :class="[
                  active_period == 'MAX' ? 'active-period-btn-mini' : '',
                ]"
              >
                MAX
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="reco-details-section">
        <div v-if="activeSubMenuLink == 'EXPERTS_HUB'">
          <ExpertsHub
            @filters="getFilterList"
            @resetAllSelectedFilters="resetAllSelectedFilters"
            :active_period="active_period"
          ></ExpertsHub>
        </div>

        <div v-if="activeSubMenuLink == 'TOP_EXPERTS'">
          <TopPerformersTopExperts
            @filters="getFilterList"
            @resetAllSelectedFilters="resetAllSelectedFilters"
            :active_period="active_period"
          >
          </TopPerformersTopExperts>
        </div>

        <div v-if="activeSubMenuLink == 'TOP_STOCKS'">
          <TopPerformersTopStocks
            @filters="getFilterList"
            @resetAllSelectedFilters="resetAllSelectedFilters"
            :active_period="active_period"
          >
          </TopPerformersTopStocks>
        </div>

        <div v-if="activeSubMenuLink == 'TOP_SECTORS'">
          <TopPerformersTopSectors
            @filters="getFilterList"
            @resetAllSelectedFilters="resetAllSelectedFilters"
            :active_period="active_period"
          >
          </TopPerformersTopSectors>
        </div>

        <HomePageDashboardMobileFilterDialog
          v-if="!isDesktop"
          :active_sub_menu="activeSubMenuLink"
          :filterList="filter_list"
          :resetFilters="reset_filter"
          class="nav-filter-icon"
        >
        </HomePageDashboardMobileFilterDialog>
      </div>
    </div>


    <!-- video dialog -->
    <div id="video-section">
      <el-dialog
        :visible.sync="videoDialog"
        :before-close="videoDialogClose"
        center
      >
        <iframe
          id="videoId"
          width="100%"
          height="600px"
          :src="activeVideo"
          title="YouTube video player"
          frameborder="0"
          allowscriptaccess="always"
          allow="accelerometer; autoplay:true; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import { HelperNetworkCallBack } from "../mixins/Helper";
import { screenSize } from "../mixins/ScreenSize.js";
import HomePageSideBar from "@/components/HomePageSideBar.vue";
import MobileNav from "@/components/MobileNav.vue";
import { EventBus } from "../eventBus";
import ExpertsHub from "@/components/ExpertsHub.vue";
import TopPerformersTopExperts from "@/components/TopPerformersTopExperts.vue";
import TopPerformersTopStocks from "@/components/TopPerformersTopStocks.vue";
import TopPerformersTopSectors from "@/components/TopPerformersTopSectors.vue";
import HomePageDashboardMobileFilterDialog from "@/components/HomePageDashboardMobileFilterDialog.vue";

export default {
  name: "Dashboard",

  components: {
    HomePageSideBar,
    MobileNav,
    TopPerformersTopExperts,
    TopPerformersTopStocks,
    TopPerformersTopSectors,
    ExpertsHub,
    HomePageDashboardMobileFilterDialog,
  },

  mixins: [filterCallBack, HelperNetworkCallBack, screenSize],

  data() {
    return {
      nav_title: "Home",
      profile_pic: require("../assets/images/navBar/avatar.jpg"),
      active_link: "TOP_PERFORMERS",
      // activeSubMenuLink: "EXPERTS_HUB",
      filter_list: "",
      reset_filter: false,
      plan_sub_noitificaion_dialog_visibility: false,
      default_active_filter: "Market Participants",
      active_period: "1M",
      campaignId: null,
      notificationData: [],
      activeVideo: "https://youtube-nocookie.com/embed/QkUAhPDy81I",
      videoDialog: false,
    };
  },

  beforeRouteLeave(to, from, next) {
    // on route leave set active default sub menu -- commited active menu in vue store
    this.$store.commit("commitDashboardActiveSubMenue", "EXPERTS_HUB");

    next();
  },

  beforeCreate() {
    if (localStorage.getItem("profile")) {
      setTimeout(() => {
        var websiteUserType = localStorage.getItem("websiteUserType")
          ? JSON.parse(localStorage.getItem("websiteUserType"))
          : {};
        var userProfile = JSON.parse(localStorage.getItem("profile"));

        var internalTeamList = [
          "krishaa0801@gmail.com",
          "joshiakshay719@gmail.com",
          "fegde.mayur@gmail.com",
          "snehalvpatil25@gmail.com",
          "sumittarkas0001@gmail.com",
          "bid.pallavi@gmail.com",
          "pallavi.bid@stockants.com",
          "bhushanm705811@gmail.com",
          "admin@stockants.com",
          "sumittarkas001@gmail.com",
          "satavchetan08@gmail.com",
          "amanm3047@gmail.com",
        ];

        userProfile.email = userProfile.email.toLowerCase();

        if (
          websiteUserType &&
          websiteUserType.userType == "stockAnts" &&
          internalTeamList.includes(userProfile.email)
        ) {
          this.isAdmin = true;
        }
      }, 0);
    }
  },

  mounted() {

    if (this.$store.state.dashboardActivePeriod) {
      this.active_period = this.$store.state.dashboardActivePeriod;
    } else {
      this.active_period = "1M";
    }

    EventBus.$on("activeHomePageLink", (event) => {
      this.setActiveLink(event); //called set active link function on emitted event from sidebar
    });

    if (this.userProfile.picture) {
      this.profile_pic = serverHostName + this.userProfile.picture;
    }

    if (this.userProfile.utm_source == "Bigul") {
      this.setActiveSubMenuLink("TOP_EXPERTS");
    }

    // check plans
    this.$root.$emit("getCampaignData");
  },

  methods: {
    videoDialogClose() {
      this.videoDialog = false;
      let video = document.getElementById("videoId");
      let url = video.getAttribute("src");
      video.setAttribute("src", "");
      video.setAttribute("src", url);
    },
    selectPeriod(period) {
      if (period == "1M") {
        this.active_period = "1M";
      } else if (period == "3M") {
        this.active_period = "3M";
      } else if (period == "6M") {
        this.active_period = "6M";
      } else if (period == "1Y") {
        this.active_period = "1Y";
      } else if (period == "MAX") {
        this.active_period = "MAX";
      }
    },

    //set cookie to avoid showing explanatory screener
    setCookieForScreener() {
      var d = new Date();
      d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie =
        "isScreenerSeen" + "=" + true + ";" + expires + ";path=/";
    },

    //get cookie to check that user has seen screener or not
    getCookieForScreener() {
      const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith("isScreenerSeen"));
      if (cookieValue) {
        cookieValue.split("=")[1];
        return cookieValue;
      } else {
        return false;
      }
    },

    getFilterList(list) {
      this.filter_list = list;
    },

    //to reset all selected filters after changing sub menu or changing tables headers
    resetAllSelectedFilters() {
      this.reset_filter = !this.reset_filter;
    },

    //getting event from home page sidebar
    setActiveLink(label) {
      if (label == "TOP_PERFORMERS") {
        this.active_link = label;
      }
    },

    //set active sub menu links e.g. last reco, accuracy achieved
    setActiveSubMenuLink(label) {
      if (label == "TOP_EXPERTS") {
        this.$store.commit("commitDashboardActiveSubMenue", "TOP_EXPERTS");
        // this.activeSubMenuLink = label;
        this.default_active_filter = "Market Participants"; //key to set by default active filter tab on side bar --(HomePageSideBar.vue)
      } else if (label == "TOP_STOCKS") {
        this.$store.commit("commitDashboardActiveSubMenue", "TOP_STOCKS");
        // this.activeSubMenuLink = label;
        this.default_active_filter = "Search stock"; //key to set by default active filter tab on side bar --(HomePageSideBar.vue)
      } else if (label == "TOP_SECTORS") {
        this.$store.commit("commitDashboardActiveSubMenue", "TOP_SECTORS");
        // this.activeSubMenuLink = label;

        this.default_active_filter = "Sectors"; //key to set by default active filter tab on side bar --(HomePageSideBar.vue)
      } else if (label == "EXPERTS_HUB") {
        this.$store.commit("commitDashboardActiveSubMenue", "EXPERTS_HUB");
        // this.activeSubMenuLink = label;
        this.default_active_filter = "Market Participants"; //key to set by default active filter tab on side bar --(HomePageSideBar.vue)
      }

      this.active_period = "1M";

      this.resetAllSelectedFilters();

      // on menu select scroll page to top
      var elmnt = document.getElementsByClassName("Dashboard")[0];
      scrollTo(elmnt, 0, 100);

      // EventBus.$emit('emitActiveMenu', label);  //emitted event in homepage sidebar page
    },
  },

  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    activeSubMenuLink() {
      return this.$store.state.active_dashboard_submenu;
    },
  },
};
</script>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.Dashboard {
  min-height: 100vh;
  background-color: $page-background-color;
  padding: 60px 0 0 0;
}

.Dashboard .reco-details-container {
  width: calc(100% - 265px);
  margin-left: 265px;
  min-height: 100vh;
}

.Dashboard .reco-details-section {
  padding: 65px 10px 0 10px;
}

.Dashboard .sub-menu-bar-wrapper {
  background: $page-background-color;
  width: calc(100% - 265px);
}

.Dashboard .footer-section {
  width: calc(100% - 260px);
  margin-left: 260px;
}

.no-data-labels {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
}

.axis-description {
  color: #333;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
}

.Dashboard .screener-dialog {
  .el-dialog {
    width: 80%;
    margin-top: 10vh !important;
  }

  .el-dialog__body {
    padding: 10px 20px 10px 20px;
  }

  .desktop_view_screener_images {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .mobile_view_screener_images {
    margin: 0 auto;
    height: 100%;
    max-width: 425px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}

.Dashboard .plan-notification-dialog {
  .el-dialog {
    width: 40%;
    border-radius: 10px;
  }
}

@media screen and (max-width: 1283px) {
  .Dashboard {
    padding: 50px 0 0 0;
  }

  .Dashboard .sub-menu-bar {
    width: 100%;
  }

  .Dashboard .reco-details-container,
  .Dashboard .sub-menu-bar-wrapper,
  .Dashboard .footer-section {
    width: 100%;
    margin-left: 0;
  }

  .Dashboard .reco-details-section {
    padding: 60px 10px 0 10px;
  }

  .Dashboard .sideBarSection {
    display: none;
  }
}

@media screen and (max-width: 600px) {
  .Dashboard .screener-dialog {
    .el-dialog {
      width: 94%;
    }
  }
}

@media screen and (max-width: 850px) {
  .Dashboard .plan-notification-dialog {
    .el-dialog {
      width: 94%;
    }
  }
}
</style>
